import api from './AxiosService';

const AdminService = {
  login: (email, password) => api.post('/admin/login', { email, password }),
  register: (data) => api.post('/admin/register', data),
  getDashboardStats: (timeframe = '7d') => api.get(`/admin/dashboard-stats?timeframe=${timeframe}`),
  getAllStaff: () => api.get('/admin'),
  getStaffById: (id) => api.post(`/admin/${id}`),
  addStaff: (staffData) => api.post('/admin/add', { staffData }),
  updateStaff: (id, data) => api.put(`/admin/${id}`, data),
  deleteStaff: (id) => api.delete(`/admin/${id}`),
  updateStaffStatus: (id, status) => api.put(`/admin/update-status/${id}`, { status }),
  updatePartnerLinks: (partnerId, data) => api.put(`/admin/partner-links/${partnerId}`, data),
  getBrands: () => api.get('/admin/all-brands'),
  getInstitutes: () => api.get('/admin/all-institutes'),
  getPartnerVerifications: (params) => api.get('/admin/verifications/all', { params }),
  reviewPartnerVerification: (id, data) => api.post(`/admin/verifications/review/${id}`, data),
  triggerPartnerSettlement: (partnerId) => api.post('/admin/verifications/trigger-settlement', { partnerId }),
  getCommissionConfig: () => api.get('/admin/verifications/commission-config'),
  updateCommissionConfig: (data) => api.post('/admin/verifications/commission-config', data),
  setPartnerCommission: (partnerId, commissionType, commissionValue) => api.post('/admin/verifications/set-partner-commission', { partnerId, commissionType, commissionValue }),
};

export default AdminService;
